module.exports = __webpack_public_path__ + "img/face9.ac2375c5.gif";